"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientFeesCannotExceedClinicFees = void 0;
/**
 * Fees paid by the client cannot exceed the fees charged to the clinic by Otto
 * @param clientFees How much the pet parent is charged by the clinic
 * @param clinicFees How much the clinic is charged by Otto
 * @returns
 */
function ClientFeesCannotExceedClinicFees(clientFees, clinicFees) {
    return clientFees <= clinicFees;
}
exports.ClientFeesCannotExceedClinicFees = ClientFeesCannotExceedClinicFees;
//# sourceMappingURL=ClientFeesCannotExceedClinicFees.js.map